import type { Command } from '../types/terminal'

// Navigation commands that should appear in help
const NAVIGATION_COMMANDS = ['cv'] as const

// Commands that should be hidden from help
const HIDDEN_FROM_HELP = ['event'] as const

// Base commands (excluding 'help' which is added dynamically)
const BASE_COMMANDS = ['clear'] as const

// Generate help text dynamically
export const generateHelpText = (): string => {
  const commands: string[] = ['help']

  // Add base commands
  BASE_COMMANDS.forEach(cmd => {
    commands.push(cmd)
  })

  // Add navigation commands (excluding hidden ones)
  NAVIGATION_COMMANDS.forEach(cmd => {
    if (!HIDDEN_FROM_HELP.includes(cmd as any)) {
      commands.push(cmd)
    }
  })

  return `Available commands: ${commands.join(', ')}`
}

// Add your commands here
export const HIDDEN_COMMANDS: Command[] = [
  { cmd: 'help', output: generateHelpText() },
  { cmd: 'clear', output: '' },
]

